
import { GspRoleState } from './types';

export const state = (): GspRoleState => initialState();

export const initialState = (): GspRoleState => ({
  gspRole: undefined,
  gspRoleContactTypes: undefined,
  gspRoles: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name'],
      andClauseFieldsIds: [],
    },
  },
});
